import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { makeEnvironmentProviders } from '@angular/core';
import { LoadingInterceptor } from './loading.interceptor';
import { LoadingService } from './loading.service';

export const provideLoading = () => makeEnvironmentProviders([
  LoadingService,
  {
    provide: HTTP_INTERCEPTORS,
    useClass: LoadingInterceptor,
    multi: true
  },
  provideHttpClient(withInterceptorsFromDi())
]);
